import { Accordion } from '@mantine/core';
import { FC, ReactNode } from 'react';

import CircularLoader from '@/components/CircularLoader.tsx';

interface Props {
    title: string;
    children: ReactNode;
    isLoading?: boolean;
}

const CollapsableItem: FC<Props> = ({ title, children, isLoading = false }) => {
    return (
        <Accordion.Item value={title} className="w-full rounded-lg border bg-white">
            <Accordion.Control className="px-4 text-sm uppercase text-slate-500">
                <div className="flex items-center gap-2">
                    <span>{title}</span>
                    {isLoading && <CircularLoader size="xs" />}
                </div>
            </Accordion.Control>
            <Accordion.Panel className="px-4">{children}</Accordion.Panel>
        </Accordion.Item>
    );
};

export default CollapsableItem;
